module.exports = __webpack_public_path__ + "static/img/102423.75ef0801.png";